import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.schedulesProgramming],
        config: {
            headerName: getLocalizedString("shiftName"),
            field: "turnCodeString",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.schedulesProgramming],
        config: {
            headerName: getLocalizedString("shift"),
            field: "turnCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.schedulesProgramming],
        config: {
            headerName: getLocalizedString("scheduleDate"),
            field: "scheduleDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.schedulesProgramming],
        config: {
            headerName: getLocalizedString("scheduleCode"),
            field: "scheduleCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.schedulesProgramming],
        config: {
            headerName: getLocalizedString("scheduleName"),
            field: "scheduleCodeString",
            filter: "agTextColumnFilter",
        }
    },
]